module.exports = __webpack_public_path__ + "static/media/lauren.b27700bd.png";